export const siteData = [
  {
    site_id: 2,
    site_name: 'Depot LPG Dumai',
    region_id: 2,
    subsidiary_id: 2,
    subholding_id: 1,
  },
  {
    site_id: 59,
    site_name: 'Depot LPG Cilacap',
    region_id: 5,
    subsidiary_id: 2,
    subholding_id: 1,
  },
  {
    site_id: 96,
    site_name: 'Depot LPG Balikpapan',
    region_id: 7,
    subsidiary_id: 2,
    subholding_id: 1,
  },
  {
    site_id: 251,
    site_name: 'Block A (Natuna Sea)',
    region_id: 82,
    subsidiary_id: 18,
    subholding_id: 6,
  },
  {
    site_id: 260,
    site_name: 'JOB Pertamina Medco E&P Simenggaris',
    region_id: 83,
    subsidiary_id: 19,
    subholding_id: 6,
  },
  {
    site_id: 11,
    site_name: 'DPPU Sultan Iskandar Muda',
    region_id: 2,
    subsidiary_id: 2,
    subholding_id: 1,
  },
  {
    site_id: 12,
    site_name: 'TBBM Dumai',
    region_id: 2,
    subsidiary_id: 2,
    subholding_id: 1,
  },
  {
    site_id: 13,
    site_name: 'TBBM Gunung Sitoli',
    region_id: 2,
    subsidiary_id: 2,
    subholding_id: 1,
  },
  {
    site_id: 14,
    site_name: 'TBBM Kabil',
    region_id: 2,
    subsidiary_id: 2,
    subholding_id: 1,
  },
  {
    site_id: 15,
    site_name: 'TBBM Kijang',
    region_id: 2,
    subsidiary_id: 2,
    subholding_id: 1,
  },
  {
    site_id: 16,
    site_name: 'TBBM Kisaran',
    region_id: 2,
    subsidiary_id: 2,
    subholding_id: 1,
  },
  {
    site_id: 17,
    site_name: 'TBBM Kreung raya',
    region_id: 2,
    subsidiary_id: 2,
    subholding_id: 1,
  },
  {
    site_id: 18,
    site_name: 'TBBM Lhokseumawe',
    region_id: 2,
    subsidiary_id: 2,
    subholding_id: 1,
  },
];

export const subsidiaryData = [
  {
    subsidiaryId: '1',
    subsidiaryName: 'PT Pertamina Lubricant',
  },
  {
    subsidiaryId: '2',
    subsidiaryName: 'PT Pertamina Patra Niaga',
  },
  {
    subsidiaryId: '3',
    subsidiaryName: 'PT Pertamina Retail',
  },
  {
    subsidiaryId: '4',
    subsidiaryName: 'Nusantara Regas',
  },
  {
    subsidiaryId: '5',
    subsidiaryName: 'Pertagas',
  },
  {
    subsidiaryId: '6',
    subsidiaryName: 'PGN',
  },
  {
    subsidiaryId: '7',
    subsidiaryName: 'Pertamina International Shipping',
  },
  {
    subsidiaryId: '8',
    subsidiaryName: 'Pertamina Trans Kontinental',
  },
  {
    subsidiaryId: '9',
    subsidiaryName: 'Peteka Karya Tirta',
  },
  {
    subsidiaryId: '10',
    subsidiaryName: 'PGE',
  },
  {
    subsidiaryId: '11',
    subsidiaryName: 'PPI',
  },
  {
    subsidiaryId: '12',
    subsidiaryName: 'PT KPB',
  },
  {
    subsidiaryId: '13',
    subsidiaryName: 'PT Pertamina Kilang International',
  },
  {
    subsidiaryId: '14',
    subsidiaryName: 'Badak NGL',
  },
  {
    subsidiaryId: '15',
    subsidiaryName: 'Elnusa',
  },
  {
    subsidiaryId: '16',
    subsidiaryName: 'Pertamina Drilling Service Indonesia',
  },
  {
    subsidiaryId: '17',
    subsidiaryName: 'Region 1 (Pertamina Hulu Rokan)',
  },
  {
    subsidiaryId: '18',
    subsidiaryName: 'Region 2 (Pertamina EP)',
  },
  {
    subsidiaryId: '19',
    subsidiaryName: 'Region 3 (Pertamina Hulu Indonesia)',
  },
  {
    subsidiaryId: '20',
    subsidiaryName: 'Region 4 (Pertamina EP Cepu)',
  },
  {
    subsidiaryId: '21',
    subsidiaryName: 'Region 5 (Pertamina International EP)',
  },
];

export const subholdingData = [
  {
    subholdingId: '1',
    subholdingName: 'Commercial & Trading',
  },
  {
    subholdingId: '2',
    subholdingName: 'Gas',
  },
  {
    subholdingId: '3',
    subholdingName: 'Integrated Marine Logistics',
  },
  {
    subholdingId: '4',
    subholdingName: 'Power & NRE',
  },
  {
    subholdingId: '5',
    subholdingName: 'Refinery & Petrochemical',
  },
  {
    subholdingId: '6',
    subholdingName: 'Upstream',
  },
];

export const regionData = [
  {
    regionId: '1',
    regionName: 'PT Pertamina Lubricant',
  },
  {
    regionId: '2',
    regionName: 'Marketing Operation Region I',
  },
  {
    regionId: '3',
    regionName: 'Marketing Operation Region II',
  },
  {
    regionId: '4',
    regionName: 'Marketing Operation Region III',
  },
  {
    regionId: '5',
    regionName: 'Marketing Operation Region IV',
  },
  {
    regionId: '6',
    regionName: 'Marketing Operation Region V',
  },
  {
    regionId: '7',
    regionName: 'Marketing Operation Region VI',
  },
  {
    regionId: '8',
    regionName: 'Marketing Operation Region VII',
  },
  {
    regionId: '9',
    regionName: 'Marketing Operation Region VIII',
  },
  {
    regionId: '10',
    regionName: 'Project',
  },
  {
    regionId: '11',
    regionName: 'PT Pertamina Patra Niaga',
  },
  {
    regionId: '12',
    regionName: 'PT Pertamina Retail',
  },
  {
    regionId: '13',
    regionName: 'Nusantara Regas',
  },
  {
    regionId: '14',
    regionName: 'ACEH & NORTH SUMATERA GAS PIPELINE',
  },
  {
    regionId: '15',
    regionName: 'EAST JAVA GAS PIPELINE',
  },
  {
    regionId: '16',
    regionName: 'KALIMANTAN GAS PIPELINE',
  },
  {
    regionId: '17',
    regionName: 'Perta Arun Gas',
  },
  {
    regionId: '18',
    regionName: 'Perta Daya Gas',
  },
  {
    regionId: '19',
    regionName: 'Pertagas Niaga',
  },
  {
    regionId: '20',
    regionName: 'Perta Samtan Gas',
  },
  {
    regionId: '21',
    regionName: 'PIPA GAS BELAWAN - KIM - KEK',
  },
  {
    regionId: '22',
    regionName: 'PIPA GAS DURI - DUMAI',
  },
  {
    regionId: '23',
    regionName: 'PIPA GAS GRESIK-PKG LOOPING',
  },
  {
    regionId: '24',
    regionName: 'PIPA GAS GRISSIK-PUSRI',
  },
  {
    regionId: '25',
    regionName: 'PIPA GAS MUARA KARANG-MUARA TAWAR-TEGALGEDE',
  },
  {
    regionId: '26',
    regionName: 'PIPA GAS PORONG-GRATI',
  },
  {
    regionId: '27',
    regionName: 'PIPA GAS PORTI - ORF SEMARE',
  },
  {
    regionId: '28',
    regionName: 'PIPA GAS RUAS ARUN - BELAWAN/ ARUN',
  },
  {
    regionId: '29',
    regionName: 'PROYEK PIPA GAS GRESIK - SEMARANG',
  },
  {
    regionId: '30',
    regionName: 'SOUTH SUMATERA GAS PIPELINE',
  },
  {
    regionId: '31',
    regionName: 'TERMINAL PENERIMAAN & REGASIFIKASI LNG ARUN',
  },
  {
    regionId: '32',
    regionName: 'WEST JAVA GAS PIPELINE',
  },
  {
    regionId: '33',
    regionName: 'GAGAS',
  },
  {
    regionId: '34',
    regionName: 'KJG',
  },
  {
    regionId: '35',
    regionName: 'Pgas Solution',
  },
  {
    regionId: '36',
    regionName: 'PGN',
  },
  {
    regionId: '37',
    regionName: 'PGN COM',
  },
  {
    regionId: '38',
    regionName: 'PGN Mas Group',
  },
  {
    regionId: '39',
    regionName: 'PLI Group',
  },
  {
    regionId: '40',
    regionName: 'SAKA',
  },
  {
    regionId: '41',
    regionName: 'TGI',
  },
  {
    regionId: '42',
    regionName: 'Pertamina International Shipping',
  },
  {
    regionId: '43',
    regionName: 'Pertamina Trans Kontinental',
  },
  {
    regionId: '44',
    regionName: 'Peteka Karya Tirta',
  },
  {
    regionId: '45',
    regionName: 'PGE Area Kamojang',
  },
  {
    regionId: '46',
    regionName: 'PGE Area Karaha',
  },
  {
    regionId: '47',
    regionName: 'PGE Area Lahendong',
  },
  {
    regionId: '48',
    regionName: 'PGE Area Lumut Balai',
  },
  {
    regionId: '49',
    regionName: 'PGE Area Sibayak',
  },
  {
    regionId: '50',
    regionName: 'PGE Area Ulubelu',
  },
  {
    regionId: '51',
    regionName: 'PPI',
  },
  {
    regionId: '52',
    regionName: 'PT KPB',
  },
  {
    regionId: '53',
    regionName: 'GRR Tuban',
  },
  {
    regionId: '54',
    regionName: 'RCC Balongan',
  },
  {
    regionId: '55',
    regionName: 'RDMP Balongan',
  },
  {
    regionId: '56',
    regionName: 'RDMP Cilacap',
  },
  {
    regionId: '57',
    regionName: 'RU II Dumai',
  },
  {
    regionId: '58',
    regionName: 'RU III Plaju',
  },
  {
    regionId: '59',
    regionName: 'RU III Sei Gerong',
  },
  {
    regionId: '60',
    regionName: 'RU II Sei Pakning',
  },
  {
    regionId: '61',
    regionName: 'RU IV',
  },
  {
    regionId: '62',
    regionName: 'RU V',
  },
  {
    regionId: '63',
    regionName: 'RU VI',
  },
  {
    regionId: '64',
    regionName: 'RU VII',
  },
  {
    regionId: '65',
    regionName: 'Badak NGL',
  },
  {
    regionId: '66',
    regionName: 'Elnusa',
  },
  {
    regionId: '67',
    regionName: 'Elnusa Daya Kreatif',
  },
  {
    regionId: '68',
    regionName: 'Elnusa Fabrikasi Konstruksi',
  },
  {
    regionId: '69',
    regionName: 'Elnusa Oilfield Services',
  },
  {
    regionId: '70',
    regionName: 'Elnusa Petrofin',
  },
  {
    regionId: '71',
    regionName: 'Elnusa Trans Samudra',
  },
  {
    regionId: '72',
    regionName: 'Patra Nusa Data',
  },
  {
    regionId: '73',
    regionName: 'Sigma Cipta Utama',
  },
  {
    regionId: '74',
    regionName: 'Pertamina Drilling Contractor Indonesia',
  },
  {
    regionId: '75',
    regionName: 'Pertamina Drilling Service Indonesia',
  },
  {
    regionId: '76',
    regionName: 'Zone 1',
  },
  {
    regionId: '77',
    regionName: 'Zone 2',
  },
  {
    regionId: '78',
    regionName: 'Zone 3',
  },
  {
    regionId: '79',
    regionName: 'Zone 4',
  },
  {
    regionId: '80',
    regionName: 'Zone 5',
  },
  {
    regionId: '81',
    regionName: 'Zone 6',
  },
  {
    regionId: '82',
    regionName: 'Zone 7',
  },
  {
    regionId: '83',
    regionName: 'Zone 10',
  },
  {
    regionId: '84',
    regionName: 'Zone 8',
  },
  {
    regionId: '85',
    regionName: 'Zone 9',
  },
  {
    regionId: '86',
    regionName: 'Zone 11',
  },
  {
    regionId: '87',
    regionName: 'Zone 12',
  },
  {
    regionId: '88',
    regionName: 'Zone 13',
  },
  {
    regionId: '89',
    regionName: 'Zone 14',
  },
  {
    regionId: '90',
    regionName: 'Zone 15',
  },
  {
    regionId: '91',
    regionName: 'Zone 16',
  },
  {
    regionId: '92',
    regionName: 'Zone 17',
  },
];

// Questionnaire Collections
// --for dummy--
export const inputList1 = [
  {
    questionId: 1,
    categoryId: 1,
    question: 'Nama Fasilitas',
    score: 100,
    dataType: 'text',
    answerList: null,
    unit: null,
    description: null,
  },
  {
    questionId: 2,
    categoryId: 1,
    question: 'Zona',
    score: 100,
    dataType: 'text',
    answerList: null,
    unit: null,
    description: null,
  },
  {
    questionId: 3,
    categoryId: 1,
    question: 'Region',
    score: 100,
    dataType: 'text',
    answerList: null,
    unit: null,
    description: null,
  },
  {
    questionId: 4,
    categoryId: 1,
    question: 'Unit',
    score: 100,
    dataType: 'text',
    answerList: null,
    unit: null,
    description: null,
  },
  {
    questionId: 10,
    categoryId: 1,
    question: 'Klasifikasi Indiustri',
    score: 100,
    dataType: 'option',
    answerList:
      '["Upstream", "Refining & Petrochemical", "Commercial & Trading", "Power & NRE", "Gas", "Integrated Marine Logistic Company"]',
    unit: null,
    description: null,
  },
];

export const inputList2 = [
  {
    questionId: 31,
    categoryId: 2,
    question: 'masalah air di masa depan',
    score: 100,
    dataType: 'longtext',
    answerList: null,
    unit: null,
    description: 'Identifikasi dampak dan tren yang harus diantisipasi',
  },
  {
    questionId: 32,
    categoryId: 2,
    question: 'resiko air yang dihadapi wilayah operasional',
    score: 100,
    dataType: 'longtext',
    answerList: null,
    unit: null,
    description:
      'Identifikasi  tingkat keparahan dampak dalam jangka waktu tertentu, potensi biaya, dan dampak bisnis',
  },
  {
    questionId: 33,
    categoryId: 2,
    question: 'masalah bersama terkait air untuk daerah tangkapan air',
    score: 100,
    dataType: 'longtext',
    answerList: null,
    unit: null,
    description: 'Identified and prioritized from the information gathered',
  },
];

// Water Category Content
// dummy fetched data from API (Names of water sources)
export const waterSourcesData = [
  {
    name: 'sumber 1',
  },
  {
    name: 'sumber 2',
  },
  {
    name: 'sumber 3',
  },
];

// dummy fetched data from API (Water Receiving Body's Names)
export const receivingBodyData = [
  {
    name: 'Company 1',
  },
  {
    name: 'Company 2',
  },
  {
    name: 'Company 3',
  },
];
